import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  FwButtonComponent,
  FwDialogActionsComponent,
  FwDialogComponent,
  FwDialogContentComponent,
  FwFormHeadingComponent,
  FwLayoutPanelComponent,
  FwSectionHeadingComponent,
  FwTextInputComponent,
} from '@flywheel-io/vision';

import { CoreApiService } from '../../core-api.service';
import { LoggingService } from '../../logging.service';
import { NotificationService } from '../../notification.service';
import { DataView, DataViewPayload } from '../../shared/models/data-view.model';

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'data-view-promote-dialog',
  },
  imports: [
    CommonModule,
    FwButtonComponent,
    FwDialogActionsComponent,
    FwDialogComponent,
    FwDialogContentComponent,
    FwFormHeadingComponent,
    FwLayoutPanelComponent,
    FwSectionHeadingComponent,
    FwTextInputComponent,
    ReactiveFormsModule,
  ],
  selector: 'data-view-promote-dialog',
  templateUrl: './data-view-promote-dialog.component.html',
})
export class DataViewPromoteDialogComponent {
  public form: FormGroup;
  public dialogDescription = '';

  constructor(
    @Inject(DIALOG_DATA) public data: DataView,
    private coreApi: CoreApiService,
    private logger: LoggingService,
    private notifications: NotificationService,
    public dialogRef: DialogRef<DataViewPromoteDialogComponent>,
  ) {
    this.dialogDescription = `This will promote the data view labeled "${data.label}" to the sitewide Shared Data Views, making this data view available to all projects.`;
    this.form = new FormGroup({
      label: new FormControl(data.label, [Validators.required]),
      description: new FormControl(data.description),
    });
  }

  onPromote(): void {
    const data = this.form.getRawValue();
    for (const key of Object.keys(this.data)) {
      if (!['_id', 'created', 'modified', 'parent', 'origin', 'label', 'description'].includes(key)) {
        data[key] = this.data[key];
      }
    }
    this.coreApi.views.promote(data as DataViewPayload)
      .subscribe({
        next: () => this.notifications.success('views.promote.success'),
        error: error => {
          this.notifications.error('views.promote.error');
          this.logger.error(error);
        },
      });
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
